﻿window.cObjetPlanitiReunionMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Réunion planiti"; }
    this.mGetAttributBase = function () { return "la" }
    this.mGetNewLib = function () { return "Nouvelle réunion planiti"; }
    this.mGetLib1 = function (option) {
        var txt = "Réunion planiti"
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-square-share-nodes' title='Planiti'></i>");
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();

    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        //contentElement.css("line-height", "1.2")

        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)

        var colspan = 1
        if (dataTemplate.id_utilisateurs != null) dataTemplate.id_utilisateurs.split(",").forEach(function (idUti) {
            var $TdUti = $("<td style='width:30px;padding:0 3px;height:22px;'/>").appendTo($Tr)
            $("<div style='width:100%;height:100%;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgSimpleStrConUti({
                bddCtrl: objet.bddRef,
                idTable: objet.bddRef.getObjet("utilisateur").mGetTable().id_table,
                id: idUti,
                text: objet.bddRef.getObjet("utilisateur", idUti).mGetLib1()
            })
            colspan += 1
        })
        var $TdNom = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;font-weight:bold;'>" + dataTemplate.planiti_nom + "</td>").appendTo($Tr)

        var $Tr = $("<tr/>").appendTo($Table)
        var txtReu = ""
        switch (parseInt(dataTemplate.id_type_lieu)) {
            case 0: txtReu = "Réunion téléphonique"; break;
            case 1: txtReu = "Réunion ZOOM"; break;
        }
        if (dataTemplate.is_annule == "1") { txtReu += " <span style='color:red;'>(annulée)</span>" }
        var $TdCarte = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;' colspan='" + colspan + "'>" + txtReu + "</td>").appendTo($Tr)
        if (dataTemplate.lstemailorga != null && dataTemplate.lstemailorga.length > 0) {
            var $Tr = $("<tr/>").appendTo($Table)
            var $TdCarte = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;' colspan='" + colspan + "'><span style='opacity:0.3'>Organisateur: </span>(" + dataTemplate.lstemailorga.split(",").length + ") " + dataTemplate.lstemailorga + "</td>").appendTo($Tr)
        }
        if (dataTemplate.lstemailinvit != null && dataTemplate.lstemailinvit.length > 0) {
            var $Tr = $("<tr/>").appendTo($Table)
            var $TdCarte = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;' colspan='" + colspan + "'><span style='opacity:0.3'>Invité: </span>(" + dataTemplate.lstemailinvit.split(",").length + ") " + dataTemplate.lstemailinvit + "</td>").appendTo($Tr)
        }
        //var $Tr = $("<tr/>").appendTo($Table)
        //var $TdCarte = $("<td style='width:100%;' colspan='" + colspan + "'><span style='opacity:0.3'>Texte info: </span>" + dataTemplate.text_info + "</td>").appendTo($Tr)
        var $Tr = $("<tr/>").appendTo($Table)
        var $TdCarte = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;font-style:italic;font-family:barlow condensed;' colspan='" + colspan + "'></td>").appendTo($Tr).text(dataTemplate.commentaire).attr("title", dataTemplate.commentaire)

        if (dataTemplate.is_annule == "1") {
            if (contentElement.closest(".divtemplate").length > 0) {
                contentElement.closest(".divtemplate").css("background-color", "rgba(255, 0, 0,0.5)")
            } else {
                contentElement.css("background-color", "rgba(255, 0, 0,0.5)")
            }
        }
        if (dataTemplate.date_fin < parametre.dateNow) {
            if (contentElement.closest(".divtemplate").length > 0) {
                contentElement.closest(".divtemplate").css("text-decoration", "line-through")
                //contentElement.css("opacity", "0.6")
                contentElement.closest(".divtemplate").addClass("texture_rdv_planiti")
            } else {
                contentElement.css("text-decoration", "line-through")
                //contentElement.css("opacity", "0.6")
                contentElement.parent().addClass("texture_rdv_planiti")
            }
        }

        //var txtHtml = "<b>" + ((dataTemplate.nb == null) ? "0" : dataTemplate.nb) + " <span style='opacity:0.3'>cartes</span></b>"
        //if (dataTemplate.detail_statut != null && dataTemplate.detail_statut.length > 0) {
        //    dataTemplate.detail_statut.split("|").forEach(function (data) {
        //        var idStatutProjet = data.split(",")[0]
        //        var objStatut = objet.bddRef.getObjet("projet_statut", idStatutProjet)
        //        var nb = data.split(",")[1]
        //        txtHtml += " &bull; "
        //        txtHtml += "" + ((nb == null) ? "0" : nb) + " <span style='opacity:0.3'>" + objStatut.data.nom + "</span>"
        //    })
        //}
        //$TdCarte.html(txtHtml)

    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus, option) {
        $("<span style='' title = 'Créé " + dataPlus.dcr.toDateIlya(true) + " (" + dataPlus.dcr.toFrenchDateTime() + ") &bull; Début le " + dataPlus.date_debut.toDateIlya(true) + " (" + dataPlus.date_debut.toFrenchDateTime() + ")'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
    }

    this.isPopupFullScreen = false
    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        var dxCtrl = $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentPlanitiReunion({
            bddCtrl: objet.bddRef,
            data: objet.data,
            optionPopup: option
        }).dxCtrlContentPlanitiReunion("instance")
    }

    this.mGetWidthPopup = function () { return 500 }
    this.mGetFullScreenPopup = function () { return false }

}